import store from '@/store';
import axios from 'axios';
import { BaseV1ApiService } from '@/services/backend/baseV1';

export class Fl44UnknownVolumePurchases extends BaseV1ApiService {
    constructor() {
        super('purchases/fl44_unknown_volume');
    }

    async show(id) {
        try {
            const response = await axios.get(this.getUrl(id));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getXml(id) {
        try {
            const response = await axios.get(this.getUrl(`${id}/xml`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeSigned(id, data, xml, certificate = null, signedAttachments) {
        if (!certificate) {
            certificate = store.getters.currentParsedCertificate;
        }
        try {
            await axios.post(this.getUrl(`${id}/save`), {
                ...data,
                xml: xml,
                certificate: certificate,
                signed_attachments: signedAttachments
            });
            await store.dispatch('showSuccessToast', 'Закупочная сессия сформирована');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async createDraft(payload) {
        try {
            const response = await axios.post(this.getUrl('create'), payload);
            await store.dispatch('showSuccessToast', 'Черновик извещения успешно сохранен');
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async updateDraft(id, payload) {
        try {
            const response = await axios.put(this.getUrl(`${id}/update`), payload);
            await store.dispatch('showSuccessToast', 'Черновик извещения успешно сохранен');
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getDraft(id) {
        try {
            const response = await axios.get(this.getUrl(`${id}/edit`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async retrieveTemplate() {
        try {
            const response = await axios.get(this.getUrl('create'));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getExplanationRequests(purchaseId) {
        try {
            const response = await axios.get(this.getUrl(`${purchaseId}/explanation_requests`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeExplanationRequest(purchaseId, payload) {
        try {
            const response = await axios.post(this.getUrl(`${purchaseId}/explanation_requests`), payload);
            return response.data;
        } catch (err) {
            this.handleErrors(err);
            throw err;
        }
    }

    async updateExplanationRequest(purchaseId, requestId, payload) {
        try {
            const response = await axios.put(this.getUrl(`${purchaseId}/explanation_requests/${requestId}`), payload);
            return response.data;
        } catch (err) {
            this.handleErrors(err);
            throw err;
        }
    }

    async getProposalCreateData(id) {
        try {
            const response = await axios.get(this.getUrl(`${id}/proposals/retrieve`));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getProposalXML(purchaseId, form) {
        try {
            const response = await axios.post(this.getUrl(`${purchaseId}/proposals/get_xml`), form);
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeSignedProposal(id, proposalData, xml, certificate, signedAttachments) {
        try {
            await axios.post(this.getUrl(`${id}/proposals/save`), {
                proposal: proposalData,
                xml: xml,
                certificate: certificate,
                signed_attachments: signedAttachments
            });
            await store.dispatch('showSuccessToast', 'Предложение успешно подано');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    downloadPurchasePdf(purchaseId) {
        return axios.get(this.getUrl(`${purchaseId}/pdf`), { responseType: 'blob' });
    }

    downloadPurchaseFinalProtocolPdf(purchaseId) {
        return axios.get(this.getUrl(`${purchaseId}/final_protocol_pdf`), { responseType: 'blob' });
    }

    downloadPurchaseContractPdf(purchaseId) {
        return axios.get(this.getUrl(`${purchaseId}/contract_pdf`), { responseType: 'blob' });
    }

    downloadPurchaseContractSupplementaryAgreementPdf(purchaseId, supplementaryAgreementId) {
        return axios.get(this.getUrl(`${purchaseId}/${supplementaryAgreementId}/supplementary_agreement_pdf`), { responseType: 'blob' });
    }
}
